export default {"src":"/_next/static/media/pccp-logo.175b49c2.svg","height":41,"width":171,"blurWidth":0,"blurHeight":0};